import React from "react";
import { SmallButton } from "../styles";
import { useAppTranslation } from "../../locales/translate";

interface Props {
  onEdit: () => void;
}

export const EditNameButton = ({ onEdit }: Props) => {
  const { t } = useAppTranslation();

  return (
    <SmallButton small onClick={onEdit}>
      {t("EDIT_MODAL_RENAME_BUTTON_TEXT")}
    </SmallButton>
  );
};
